<template>
  <div class="orcamento-observacoes">
    <div v-if="$slots.aviso" class="orcamento-observacoes__aviso">
      <slot name="aviso"></slot>
    </div>
    <div
      class="orcamento-observacoes__grid"
      :class="{ 'orcamento-observacoes__grid--tres': $slots.pagamento }"
    >
      <div v-if="$slots.pagamento" class="orcamento-observacoes__field">
        <slot name="pagamento"></slot>
      </div>
      <div class="orcamento-observacoes__field">
      <label class="orcamento-observacoes__label" for="textareaObservacao">
        <i class="fa fa-flag"></i>
        Observação
      </label>
      <div class="orcamento-observacoes__textarea-wrap">
        <textarea
          class="orcamento-observacoes__textarea"
          id="textareaObservacao"
          rows="4"
          maxlength="300"
          placeholder="Adicione observações relevantes ao pedido..."
          :disabled="!modoEdicao"
          v-model="obs"
          @blur="salvarObservacao()"
        ></textarea>
        <span class="orcamento-observacoes__counter">{{ restantesObs }} restantes</span>
      </div>
    </div>

    <div class="orcamento-observacoes__field">
      <label class="orcamento-observacoes__label" for="textareaObservacaoFollowUp">
        <i class="fa fa-lock"></i>
        Observação - Follow Up Interno
      </label>
      <div class="orcamento-observacoes__textarea-wrap">
        <textarea
          class="orcamento-observacoes__textarea"
          id="textareaObservacaoFollowUp"
          rows="4"
          maxlength="300"
          placeholder="Anotação interna de follow-up. Não aparece para o cliente."
          :disabled="!modoEdicao"
          v-model="obsFollowUp"
          @blur="salvarFollowUp()"
        ></textarea>
        <span class="orcamento-observacoes__counter">{{ restantesFollowUp }} restantes</span>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OrcamentoObservacoes",
  props: {
    modoEdicao: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      obs: "",
      obsFollowUp: "",
      limite: 300
    };
  },
  computed: {
    restantesObs() {
      return this.limite - (this.obs ? this.obs.length : 0);
    },
    restantesFollowUp() {
      return this.limite - (this.obsFollowUp ? this.obsFollowUp.length : 0);
    }
  },
  mounted() {
    this.carregar();
  },
  methods: {
    carregar() {
      const dados = this.$store.state.orcamento.dados || {};
      this.obs = dados.observacao || "";
      this.obsFollowUp = dados.observacao_follow_up_interno || "";
    },
    salvarObservacao() {
      this.$store.commit("orcamento/SALVAR_DADO_ORCAMENTO", { observacao: this.obs });
    },
    salvarFollowUp() {
      this.$store.commit("orcamento/SALVAR_DADO_ORCAMENTO", {
        observacao_follow_up_interno: this.obsFollowUp
      });
    }
  }
};
</script>

<style scoped>
.orcamento-observacoes {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1rem;
}

.orcamento-observacoes__aviso {
  width: 100%;
}

.orcamento-observacoes__grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.25rem 1.5rem;
}

.orcamento-observacoes__grid--tres {
  grid-template-columns: 1fr 1fr 1fr;
}

.orcamento-observacoes__field {
  min-width: 0;
}

.orcamento-observacoes__label {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  margin-bottom: 0.55rem;
  color: #1f2a37;
  font-size: 0.92rem;
  font-weight: 700;
  line-height: 1.2;
}

.orcamento-observacoes__label i {
  color: #0075eb;
  font-size: 0.9rem;
}

.orcamento-observacoes__textarea-wrap {
  position: relative;
}

.orcamento-observacoes__textarea {
  display: block;
  width: 100%;
  min-height: 135px;
  padding: 0.75rem 0.9rem 1.7rem;
  border: 1px solid #d8dee6;
  border-radius: 10px;
  background: #fff;
  color: #23282c;
  font-size: 0.92rem;
  line-height: 1.45;
  resize: vertical;
  box-shadow: none;
}

.orcamento-observacoes__textarea:focus {
  outline: none;
  border-color: #0075eb;
  box-shadow: 0 0 0 0.15rem rgba(0, 117, 235, 0.15);
}

.orcamento-observacoes__textarea:disabled {
  background: #f5f7fa;
  color: #8a94a6;
}

.orcamento-observacoes__counter {
  position: absolute;
  right: 0.85rem;
  bottom: 0.55rem;
  color: #8a94a6;
  font-size: 0.75rem;
  font-weight: 500;
  pointer-events: none;
}

@media (max-width: 991.98px) {
  .orcamento-observacoes__grid,
  .orcamento-observacoes__grid--tres {
    grid-template-columns: 1fr;
  }
}
</style>
